<ul class="progressbar col-sm-12 d-flex justify-content-center">
    <li :class="getClassStatus(step.status)" v-for="step in listStepCurrent" :key="step.iconText">{{step.label}}</li>
</ul>
